import { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'

export default function DownloadSeparator({ or }: { or: string | undefined | null }): ReactElement {
  return (
    <>
      <Flex
        sx={{
          position: 'relative',
          justifyContent: 'center',
          minHeight: '2rem',
        }}
      >
        <Text
          sx={{
            backgroundColor: 'background',
            fontWeight: 'bold',
            fontSize: '1.8rem',
            textTransform: 'uppercase',
            minWidth: '3.9rem',
            textAlign: 'center',
          }}
        >
          {or}
        </Text>
        <div
          sx={{
            position: 'absolute',
            width: '100%',
            height: '0.2rem',
            backgroundColor: 'white15',
            bottom: '50%',
            zIndex: '-1',
          }}
        />
      </Flex>
    </>
  )
}
